import * as React from 'react';
import { usePageTheme } from '../Hooks/usePageTheme';
import type { Theme } from '~/Utils/Theme';

const ThemeContext = React.createContext<Theme | null>(null);

export interface ThemeContextProviderProps {
    theme: Theme;
}

export const ThemeContextProvider: React.FC<React.PropsWithChildren<ThemeContextProviderProps>> = props => {
    const { theme, children } = props;

    return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
    const context = React.useContext(ThemeContext);
    const pageTheme = usePageTheme();

    if (!context) {
        // Fallback to page-level theme as we don't have a top level component that we can use to wrap the entire tree
        return pageTheme;
    }

    return context;
};
